import { createPostEndpoint } from '@sonar-software/sonar-http';

import { DataSecurityMonitorType, MonitorFormTypes } from '@types';

export type PostDataSecurityActionTemplatedRequest =
    Omit<MonitorFormTypes & {
        monitorTypeId: DataSecurityMonitorType,
        overwrite: boolean,
    }, 'id'>;

export const postDataSecurityActionTemplate = createPostEndpoint<PostDataSecurityActionTemplatedRequest>(
	() => '/api/v3/recommended-actions/templates'
);
